import Jar from "@/components/visual/Jar";

/** Drawn stand in until photos arrive: small jar for Chintu, a group for packs. */
export default function BottleArt({ product }) {
  const cls = "w-auto transition-transform duration-700 group-hover:scale-[1.03]";
  if (product.kind === "bundle") {
    return (
      <div className="flex items-end justify-center gap-1 h-[78%]">
        <Jar className={`h-[88%] ${cls}`} label={false} title={product.name} />
        <Jar className={`h-full ${cls}`} title={product.name} />
        <Jar className={`h-[88%] ${cls}`} label={false} title={product.name} />
      </div>
    );
  }
  if (/chintu/.test(product.slug)) return <Jar className={`h-[46%] ${cls}`} title={product.name} />;
  return <Jar className={`h-[82%] ${cls}`} title={product.name} />;
}

